import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Div, Dropdown, Flex, Gutter, OptionListOption, Title } from '@gaiads/telia-react-component-library';
import { OrganizationResponse } from '@cdaas/api-clients/dist/asset-admin-openapi';

import './ParentOrganization.scss';

interface ParentOrganizationProps {
  selectedParentOrganizationId: string | undefined;
  handleParentOrganizationChange: (option: OptionListOption | undefined) => void;
  organizationList: OrganizationResponse[];
  editingOrganizationName: string;
  error: string | undefined;
}

export default function ParentOrganization(props: ParentOrganizationProps) {
  const { selectedParentOrganizationId, handleParentOrganizationChange, organizationList, editingOrganizationName, error } = props;

  const [internalError, setInternalError] = useState(error);

  const { t } = useTranslation('organizationForm');

  const unlink = () => {
    handleParentOrganizationChange(undefined);
    setInternalError(undefined);
  };

  const handleDropdownChange = (option: OptionListOption) => {
    handleParentOrganizationChange(option);
    setInternalError(undefined);
  };

  const organizationListOptions = organizationList.map(org => {
    return { label: org.name, value: org.id };
  });

  let selectedOrganizationOption: OptionListOption | undefined;
  if (selectedParentOrganizationId && organizationList) {
    const foundOrg = organizationList.find(org => org.id === selectedParentOrganizationId);
    selectedOrganizationOption = foundOrg ? { label: foundOrg.name, value: foundOrg.id } : undefined;
  }

  let dropdownHelperText = '';
  if (selectedOrganizationOption && !internalError) {
    dropdownHelperText = t('parent_organization.helper_text', {
      interpolation: { escapeValue: false },
      parentOrganization: selectedOrganizationOption.label,
      editingOrganization: editingOrganizationName,
    });
  }

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('parent_organization.parent_organization')}</Title>
      <Flex directionColumn className={'customer-organization-form__parent-organization__inputs-container'}>
        <Gutter size="layout-5" />
        <BodyText size="sm">
          {t('parent_organization.info_text', { editingOrganization: editingOrganizationName, interpolation: { escapeValue: false } })}
        </BodyText>
        <Gutter size="layout-5" />
        <Flex alignBottom>
          <Dropdown
            className={'customer-organization-form__parent-organization__dropdown'}
            label={t('parent_organization.parent_organization_input_label')}
            selectedOption={selectedOrganizationOption}
            options={organizationListOptions}
            onChange={(_e, option) => {
              handleDropdownChange(option);
            }}
            errorText={internalError}
            name={'dropdown'}
            helperText={dropdownHelperText}
          />
        </Flex>
        <Gutter size="sm" />
        {selectedOrganizationOption && (
          <BodyText size="sm" clickableAppearance onClick={unlink} color={'purple500'}>
            {t('parent_organization.unlink')}
          </BodyText>
        )}
      </Flex>
    </Div>
  );
}
